import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../../websocket.actions';
import {filter, map, withLatestFrom} from 'rxjs/operators';
import {Prueflauf} from '../../../../clients/qschecks';
import {getPruefplanId} from '../qschecks-controlling-home/qs-checks-controlling-home.selectors';
import {QsChecksEntityTypes} from '../../../../client-constants';
import PRUEFLAUF_ENTITY = QsChecksEntityTypes.PRUEFLAUF_ENTITY;
import {PrueflaufDetailNeuLaden, VeranstaltungUebersichtNeuLadenAction} from './qs-checks-controlling-veranstaltung.actions.ui';
import {getAktuellenPrueflauf} from './qs-checks-controlling-veranstaltung.selectors';

@Injectable()
export class QsChecksControllingVeranstaltungPageWsEffects {

    @Effect()
    readModelUpdaterPrueflaufListe$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFLAUF_ENTITY && x.message.entity !== '';
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Prueflauf> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanId)))
        , filter(([x, pruefplanId]) => {
            return pruefplanId !== null && x.pruefplan_id === pruefplanId;
        })
        , map(([x, pruefplanId]) => {
            return new VeranstaltungUebersichtNeuLadenAction();
        })
    );

    @Effect()
    readModelUpdaterPrueflaufLoeschenListe$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFLAUF_ENTITY && x.message.method === 'DELETE';
        })
        , map(() => {
            return new VeranstaltungUebersichtNeuLadenAction();
        })
    );

    @Effect()
    readModelUpdaterPrueflaufAktuell$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFLAUF_ENTITY && x.message.entity !== '';
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Prueflauf> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getAktuellenPrueflauf)))
        , filter(([x, prueflauf]) => {
            return prueflauf !== null && prueflauf.prueflauf_id === x.prueflauf_id;
        })
        , map(([x, prueflauf]) => {
            return new PrueflaufDetailNeuLaden();
        })
    );

    constructor(
        private actions$: Actions,
        private store: Store<any>,
    ) {
    }
}
